import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import { youtubeParser } from 'core/common/utils/regex'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'core/components/Core/index'
import Typography from 'core/components/Typography/index'

const ProductVideoModal = ({
  handleClose,
  handleConfirm,
  isOpen,
  setLoadingVideo,
  videoLink = '',
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle disableTypography>
        <Typography fontSize="medium" variant="h4">
          {i18n.t('product.productUpload.videoModalTitle')}
        </Typography>
        <Typography fontSize="small" variant="h6" fontWeight="medium">
          {i18n.t('product.productUpload.videoModalSubtitle')}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <iframe
          title="youtubeVideo"
          width="100%"
          height="310"
          onLoad={() => setLoadingVideo(false)}
          src={`https://www.youtube.com/embed/${youtubeParser(videoLink)}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; showinfo"
          allowFullScreen
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {i18n.t('product.productUpload.close')}
        </Button>
        <Button variant="contained" onClick={handleConfirm} color="success" autoFocus>
          {i18n.t('product.productUpload.addToGalery')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ProductVideoModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setLoadingVideo: PropTypes.func.isRequired,
  videoLink: PropTypes.string.isRequired,
}

export default ProductVideoModal
